import { useEffect, useRef, useState } from 'react';
import './DestinationSelector.css';

export default function DestinationSelector({ options, value, onChange, error = false, describedBy }) {
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const trigger = useRef(null);
  const selected = options.find(option => option.value === value);

  useEffect(() => {
    if (!open) return undefined;
    const closeOutside = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    const closeOnEscape = event => { if (event.key === 'Escape') { setOpen(false); trigger.current?.focus(); } };
    document.addEventListener('pointerdown', closeOutside);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('pointerdown', closeOutside);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [open]);

  return <div ref={root} className="destination-selector">
    <input type="hidden" name="destination" value={value} />
    <button ref={trigger} className={`destination-selector__trigger${error ? ' is-invalid' : ''}`} type="button" aria-label={`Destination: ${selected?.label || 'Choose a destination'}`} aria-haspopup="listbox" aria-expanded={open} aria-describedby={describedBy} onClick={() => setOpen(state => !state)}>
      <span>{selected?.label || 'Where would you like to stay?'}</span><span className="destination-selector__chevron" aria-hidden="true">⌄</span>
    </button>
    {open && <div className="destination-selector__menu" role="listbox" aria-label="Choose a destination">
      {options.map(option => <button key={option.value} type="button" role="option" aria-selected={value === option.value} disabled={option.disabled} onClick={() => { onChange(option.value); setOpen(false); }}>
        <span>{option.label}</span>{option.disabled ? <small>Coming soon</small> : value === option.value ? <span aria-hidden="true">✓</span> : null}
      </button>)}
    </div>}
  </div>;
}
